import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ComponentProps } from 'react'
import { buttonIcon } from './Button.css'

export const ButtonIcon = (props: ComponentProps<typeof FontAwesomeIcon>) => {
  return <FontAwesomeIcon {...props} className={buttonIcon} />
}
